import "./CompanyPriceHistoryTabComponent.scss";
import template from "./CompanyPriceHistoryTabComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {TimeSeriesPeriod} from "../../../security/time-series/types/TimeSeriesPeriod";
import {BehaviorSubject, Observable, ReplaySubject} from "rxjs";
import {BreakpointObserver} from "../../../services/breakpoints/BreakpointObserver";
import {WidgetDisplayMode} from "../../../dashboard/oms/models/WidgetDisplayMode";
import {Breakpoint} from "../../../services/breakpoints/Breakpoint";

type DisplayMode = "MOBILE" | "DESKTOP";

export const CompanyPriceHistory = "tfCompanyPriceHistoryTab";

export function companyPriceHistory(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: CompanyPriceHistoryTabComponentController
    };
}

export class CompanyPriceHistoryTabComponentController {

    /** @input */
    public readonly security: CodeAndExchange;

    public readonly period = TimeSeriesPeriod.DAILY;
    public readonly mode$: Observable<DisplayMode>;
    public readonly currentAdjusted$ = new BehaviorSubject(true);

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.mode$ = this.buildDisplayMode();
    }

    private buildDisplayMode(): Observable<DisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.XS)
                   .map((bp) => bp.active)
                   .map((active) => active ? "MOBILE" : "DESKTOP")
                   .publishReplay(1)
                   .refCount();
    }

    public updateAdjusted() {
        this.currentAdjusted$.next(!this.currentAdjusted$.getValue());
    }
}
